// ─── Program Config ───────────────────────────────────────────────────────────
export const PROGRAM_ID  = "9U7hbTQEoM4vY2Uwd6RKKCz3TMvocAtEFjpHRbMxSHAQ";
export const TOKEN_MINT  = "FQwBuM6DU76rXCLrJVciS8wQUPvkS58sbtQmrxG1WgdY";
export const NETWORK     = "devnet";
export const RPC_ENDPOINT = "https://api.devnet.solana.com";

// ─── Pool Types ───────────────────────────────────────────────────────────────
export const POOL_TYPE = { MIN30: 0, HOURLY: 1, DAILY: 2 };

// ─── PDAs (derived deterministically, no deploy-time update needed) ──────────
// GlobalState:  seeds = [b"global_state"]
// PoolState:    seeds = [b"pool", &[pool_type]]  (pool_type = 0/1/2)
// AirdropState: seeds = [b"airdrop_state"]
// StakingState: seeds = [b"staking_state"]

// ─── Vault Token Accounts (created at initialize_pool / initialize time) ──────
// All pool vaults: authority = PoolState PDA
// airdrop_vault:   authority = GlobalState PDA  [b"global_state"]
// staking_vault:   authority = staking auth PDA [b"staking"]
// vesting_vault:   authority = vesting PDA      [b"vesting", beneficiary]

// Pool Vaults — filled after deploy 2026-03-01
export const POOL_30MIN_VAULT  = "J4VwzLdrpvjCsykP7P7JUR4UhvTdLnfyjcgysdQ8YuZG"; // authority = PoolState[0] PDA
export const POOL_HOURLY_VAULT = "FJW1LuZMZbD5qobN95fMFwNQoYis23CmopZBVqzB4Xps"; // authority = PoolState[1] PDA
export const POOL_DAILY_VAULT  = "GNXJ7eEtBHvh6K4Ppi3SX6skKTu7NuWCgXr99DyUeu4G"; // authority = PoolState[2] PDA

// Airdrop source vault (funds free bets; authority = GlobalState PDA) — pre-funded 100M TPOT
export const AIRDROP_VAULT     = "Gagc5bk5pNh1sk79gs13W4RSK2wwZusdSFT9ZBMAwYUo";

// Platform fee destination (plain wallet token account, no PDA)
// Wallet: F4dQpEz69oQhhsYGiCASbPNAg3XaoGggbHAeuytqZtrm
export const PLATFORM_FEE_VAULT = "2Gq8ZCP1jg3FXKaMJeEQCBJuyv1VznW5ZvYdVJvKiJQe";

// Referral rewards source (authority = GlobalState PDA)
export const REFERRAL_VAULT = "85HhmvBsE6VNGYWMWdC9WCK47mPLCVrsHGu1PxokY9xS";

// Daily 1:1 deposit matching source (authority = GlobalState PDA)
export const RESERVE_VAULT = "78zVf9GNc2DZU87jS6R5qYS4A5cdZrzR15t1LqZmboRL";

// Top-prize escrow — holds 1st/2nd/3rd prizes until vested (authority = GlobalState PDA)
export const PRIZE_ESCROW_VAULT = "G7NNS4QdM1Zau543TwdtBHwWa9UG4U1zVzAf3eS55SCK";

// Staking / vesting vaults (unchanged from old deploy)
export const STAKING_VAULT = "5CAwNZje1nyPRAKiLfPhsUAjNQu52Ymvzdo1iXBfatNt";
export const VESTING_VAULT = "939dBwYK6epmmUTAmYAco9cnCp3Vxa8MV27HBDmd3JYR";

// Platform fee wallet (controls PLATFORM_FEE_VAULT)
export const PLATFORM_FEE_WALLET = "F4dQpEz69oQhhsYGiCASbPNAg3XaoGggbHAeuytqZtrm";

// VRF Account (Switchboard VRF - set after deployment)
// Create via: ts-node scripts/create-vrf.ts
export const VRF_ACCOUNT = ""; // TODO: Fill after VRF creation

// Authority wallet (can pause/unpause protocol)
export const AUTHORITY_WALLET = "F4dQpEz69oQhhsYGiCASbPNAg3XaoGggbHAeuytqZtrm";

// ─── Pool Params ──────────────────────────────────────────────────────────────
export const POOL_CONFIG = {
  [POOL_TYPE.MIN30]:  { label: "30 Min",  duration: 1800,  minDeposit: 500  },
  [POOL_TYPE.HOURLY]: { label: "1 Hour",  duration: 3600,  minDeposit: 200  },
  [POOL_TYPE.DAILY]:  { label: "1 Day",   duration: 86400, minDeposit: 100  },
};
export const MIN_PARTICIPANTS = 12;
export const FREE_BET_AMOUNT  = 100; // TPOT
export const TPOT_DECIMALS    = 9;
export const TPOT_UNIT        = 1_000_000_000n; // 1 TPOT in raw
